import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TruncatedDefinition } from '../../../../../components/popovers/truncated-definition/TruncatedDefinition';
import { TruncatedDefinitionLink } from '../../../../../components/popovers/truncated-definition/TruncatedDefinitionLink';
import { DecisionReferences } from '../../../../../decision/legislation-snippet/references/DecisionReferences';
import { LegalTermIndemnity } from './LegalTermIndemnity';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { Spacing } from '../../../../../components/entities-card/Spacing';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { ResultsType } from '../../../../state/reducers/results.types';
import { withUser } from '../../../../../user/UserContext';
import { UserContextType } from '../../../../../user/user.types';
import { LegalTermCardTitle } from './card/LegalTermCardTitle';

type Props = {
  legalTerm: NonNullable<ResultsType['snippets']['fiche']>;
} & UserContextType &
  WithRestrictedModalProps;

export class RawSearchLegalTermSnippet extends React.Component<Props> {
  handleClick = (source: string) => () => {
    const { legalTerm, accessPremium, openRestrictedModal } = this.props;

    if (accessPremium && !!legalTerm) {
      doctrineAnalytics('Search FicheClicked', {
        reportOriginalQueryKey: true,
        ...makeLegalTermEventData(legalTerm),
      });
    } else {
      openRestrictedModal(source);
    }
  };

  render() {
    const { legalTerm, accessPremium } = this.props;

    if (!legalTerm) {
      return null;
    }

    return (
      <div className="snippet-card">
        <EntitiesCardBody>
          <LegalTermCardTitle
            target="_blank"
            onClick={this.handleClick('legal_term_title')}
            href={accessPremium ? legalTerm.url : undefined}
          >
            {legalTerm.title}
          </LegalTermCardTitle>
          <Spacing />
          {legalTerm.type === 'indemnity' && (
            <LegalTermIndemnity
              text={legalTerm.text}
              handleClick={this.handleClick('legal_term_indemnity')}
              href={accessPremium ? legalTerm.url : undefined}
            />
          )}
          {legalTerm.type === 'definition' && (
            <TruncatedDefinition text={legalTerm.text}>
              <TruncatedDefinitionLink
                target="_blank"
                onClick={this.handleClick('legal_term_definition')}
                href={accessPremium ? legalTerm.url : undefined}
              >
                <FormattedMessage id="search/components/search-snippets/main/legal-term/SearchLegalTermSnippet.tsx/1" />
              </TruncatedDefinitionLink>
            </TruncatedDefinition>
          )}
          {legalTerm.decisions.length > 0 && (
            <DecisionReferences
              accessPremium={accessPremium}
              source="search_keywords_snippet"
              decisions={legalTerm.decisions}
            />
          )}
        </EntitiesCardBody>
      </div>
    );
  }
}

export const SearchLegalTermSnippet = withRestrictedModal(
  withUser(RawSearchLegalTermSnippet),
);

function makeLegalTermEventData(
  legalTerm: NonNullable<ResultsType['snippets']['fiche']>,
) {
  return {
    title: legalTerm.title,
    url: legalTerm.url,
    decisions_length: legalTerm.decisions.length,
    text_length: legalTerm.text.length,
  };
}
